import React from 'react';

const SectionHeader = ({ title, subtitle, eyebrow, light = false }) => {
  return (
    <div className={`section-header ${light ? 'light' : ''}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
};

export default SectionHeader;
